/* eslint-disable no-unused-vars */
// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import uuid from "react-native-uuid";
import { cloneDeep, range } from "lodash";

// Components Imports

// Internal Imports
import { DOCUMENTS } from "../../constants";
import { getCellData, isTableCellMerged } from "../RevvTableV2/utils";

import { emptyCell, emptyTextEditor } from "../../utils/documentUtils";

import EditorActions from "../../actions/EditorActions";

import {
  updateDocumentClickedComponentID,
  preventEditorToDeactivate,
  updateComponentMeta,
  updateDocumentComponentAction,
  coverpageThemeAction,
} from "../../actions/DocumentActions/index";

import {
  tableAddRow,
  tableAddCol,
  tableDeleteRow,
  tableDeleteCol,
  tableRowUpdate,
  tableMetaUpdate,
  tableBatchCellsUpdate,
} from "../../actions/TableFieldActions/index";

import ManageColumnsPopup from "../DocumentItems/ManageColumnsPopup";
import EditTableApiHeaderPopup from "../DocumentItems/EditTableApiHeaderPopup";

import {
  ColorOptionBtns,
  RowOptionBtns,
  ColumnOptionBtns,
  ManageColumnBtn,
  ApplyFormulaBtn,
  MergeCellsBtn,
} from "../RevvTableV2/TableOptions/Buttons";

import { updateClauseOptionsService } from "../../actions/DocumentTemplateActions/templateService";
import { DOCUMENT_MODE } from "../../constants/document";

const { nukeActiveEditor, updateActiveComponent } = EditorActions;
// Destructuring
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class RevvTableToolBar extends Component {
  state = {
    activeToolbarDropDown: null,
    colorSelected: "",
    columnsHeaders: [],
    hiddenColumnsForGsheet:
      this.props.component &&
      this.props.component.data &&
      this.props.component.data.attributes &&
      (this.props.component.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET ||
        this.props.component.type === DOCUMENT_COMPONENT_TYPES.TABLE ||
        this.props.component.data.attributes.showManageColumnOption) &&
      this.props.component.data.attributes.hiddenCols
        ? this.props.component.data.attributes.hiddenCols
        : [],
    showEditHeaderPopupTableApi: false,
    direction: null,
    currSection: null,
    showEditHeaderPopupTableApiType: "",
  };

  componentDidMount() {
    if (
      this.props.component &&
      this.props.component.data &&
      this.props.component.data.attributes &&
      this.props.component.data.attributes.hiddenCols
    ) {
      this.setState({
        hiddenColumnsForGsheet: this.props.component.data.attributes.hiddenCols,
      });
    }
  }

  componentDidUpdate = (prevProps, nextProps) => {
    if (
      nextProps.activeToolbarDropDown === "FONT_COLOR" &&
      this.state.activeToolbarDropDown !== "FONT_COLOR"
    ) {
      this.props.handleCustomColorDropDownOpen(false, true);
    }
    if (
      prevProps.clickedActiveComponentId !== this.props.clickedActiveComponentId
    ) {
      if (this.props.activeToolbarDropDown) {
        this.props.toogleToolbarDropDown(null);
      }
    }
  };

  componentWillUnmount() {
    this.setState({ currSection: null });
  }

  _updateMultipleState = obj => {
    this.setState({
      ...obj,
    });
  };

  _showOrHideToolBar = section => {
    const {
      data: {
        attributes: { dataSource, isUnlinkedTableAPI },
      },
    } = section;
    if (dataSource === "TableApi" && !isUnlinkedTableAPI) return false;
    return true;
  };

  _showOrHideManageColsBtn = section => {
    const {
      data: {
        attributes: { isLinkedToDataSource, connected },
      },
    } = section;
    if (
      (isLinkedToDataSource && connected) ||
      (!isLinkedToDataSource && !connected)
    ) {
      return true;
    }
    return false;
  };

  _showOrHideRowColBtn = section => {
    const {
      data: {
        attributes: { editable },
      },
    } = section;
    return editable;
  };

  _showOrHideMergeBtn = section => {
    const {
      data: {
        attributes: { editable, dataSource },
      },
    } = section;
    if (dataSource === "TableApi") return false;
    return editable;
  };

  _showOrHideColorBtn = section => {
    const {
      data: {
        attributes: { dataSource, isUnlinkedTableAPI },
      },
    } = section;
    if (dataSource === "TableApi" && !isUnlinkedTableAPI) return false;
    return true;
  };

  _setMngColsData = (hdnCols, newColHdrs) => {
    const { component, clickedActiveComponentId } = this.props;
    this.setState({
      columnsHeaders: newColHdrs,
      hiddenColumnsForGsheet: hdnCols,
    });
    if (
      component &&
      (component.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET ||
        component.type === DOCUMENT_COMPONENT_TYPES.TABLE ||
        component.data.attributes.showManageColumnOption)
    ) {
      const newSection = {
        ...component,
        data: {
          attributes: {},
          ...component.data,
        },
      };
      newSection.data.attributes.hiddenCols = hdnCols;
      if (
        "columnCount" in newSection.data.attributes &&
        "originalColumnCount" in newSection.data.attributes
      ) {
        newSection.data.attributes.columnCount =
          newSection.data.attributes.originalColumnCount - hdnCols.length;
      }
      this._saveTable(newSection.data, clickedActiveComponentId);
    }
  };

  _toggleDropdown = (e, type) => {
    // e.preventDefault();

    if (type === "BackgroundColor") {
      this.props.toogleToolbarDropDown(
        this.props.activeToolbarDropDown === "BACKGROUND_COLOR"
          ? null
          : "BACKGROUND_COLOR",
      );
    } else if (type === "BorderColor") {
      this.props.toogleToolbarDropDown(
        this.props.activeToolbarDropDown === "BORDER_COLOR"
          ? null
          : "BORDER_COLOR",
      );
    }
    this.props.preventEditorToDeactivate(false);
  };

  _emptyCell = () => emptyCell(true);

  _updatedData = (component, components, tableData) => {
    let newSection;
    if (component && component.componentMeta.blockType === "COVERPAGE") {
      const coverpageComponent =
        components[component.componentMeta.coverpageId];
      newSection = {
        ...coverpageComponent.content,
        data: {
          ...coverpageComponent.content.data,
          components: {
            ...coverpageComponent.content.data.components,
            [component.id]: {
              ...coverpageComponent.content.data.components[component.id],
              content: {
                ...component,
                data: tableData,
              },
            },
          },
        },
      };
    } else if (component && component.componentMeta.blockType === "HEADER") {
      const headerComponent = components[component.componentMeta.headerId];
      newSection = {
        ...headerComponent.content,
        data: {
          ...headerComponent.content.data,
          header: {
            ...headerComponent.content.data.header,
            components: {
              ...headerComponent.content.data.header.components,
              [component.id]: {
                ...headerComponent.content.data.header.components[component.id],
                content: {
                  ...component,
                  data: tableData,
                },
              },
            },
          },
        },
      };
    } else if (component && component.componentMeta.blockType === "FOOTER") {
      const footerComponent = components[component.componentMeta.footerId];
      newSection = {
        ...footerComponent.content,
        data: {
          ...footerComponent.content.data,
          footer: {
            ...footerComponent.content.data.footer,
            components: {
              ...footerComponent.content.data.footer.components,
              [component.id]: {
                ...footerComponent.content.data.footer.components[component.id],
                content: {
                  ...component,
                  data: tableData,
                },
              },
            },
          },
        },
      };
    } else if (component && component.componentMeta.blockType === "BODY") {
      newSection = {
        ...component,
        data: tableData,
      };
    }
    return newSection;
  };

  // used to save table level changes
  _saveTable = (tableData, activeCellID, currFocusRowId, currFocusColId) => {
    // const { tableData } = this.state;
    const { component, readOnly, updateSection, components } = this.props;
    let newSection;
    let oldSection;
    if (!readOnly) {
      newSection = this.props.updatedData(component, components, tableData);
      // Picking oldSection based on blockType
      if (
        component &&
        component.componentMeta &&
        component.componentMeta.blockType === "HEADER"
      ) {
        const headerComponent = components[component.componentMeta.headerId];
        oldSection = { ...headerComponent.content };
      } else if (
        component &&
        component.componentMeta &&
        component.componentMeta.blockType === "FOOTER"
      ) {
        const footerComponent = components[component.componentMeta.footerId];
        oldSection = { ...footerComponent.content };
      } else if (
        component &&
        component.componentMeta &&
        component.componentMeta.blockType === "COVERPAGE"
      ) {
        const coverpageComponent =
          components[component.componentMeta.coverpageId];
        oldSection = { ...coverpageComponent.content };
      } else {
        oldSection = component;
      }

      this.props.updateDocumentComponentAction(newSection);
      updateSection(newSection, undefined, undefined, oldSection);
      if (activeCellID) {
        this.props.updateDocumentClickedComponentID(
          activeCellID,
          true,
          component ? component.type : null,
        );
        const newMetaData = {
          ...this.props.activeComponentMeta,
          tableCellId: activeCellID,
          tableColId: currFocusColId,
          tableRowId: currFocusRowId,
          selected: null,
        };
        this.props.updateComponentMeta(newMetaData);
      }
    }
  };

  _saveTableData = (tableData, rowID, colID, change) => {
    const { component, updateSection, readOnly, components } = this.props;

    let editable = false;
    let newSection;
    let oldSection;
    if (rowID !== null && colID !== null) {
      const cellData = getCellData(tableData, rowID, colID);
      if (cellData) {
        const { attributes } = cellData;
        editable = editable || attributes.editable;
      }
    }

    if (!readOnly || editable) {
      // newSection = this.props.updatedData(component, components, tableData);
      newSection = this.props.updatedData(component, components, tableData);
      // Picking oldSection based on blockType
      if (
        component &&
        component.componentMeta &&
        component.componentMeta.blockType === "HEADER"
      ) {
        const headerComponent = components[component.componentMeta.headerId];
        oldSection = { ...headerComponent.content };
      } else if (
        component &&
        component.componentMeta &&
        component.componentMeta.blockType === "FOOTER"
      ) {
        const footerComponent = components[component.componentMeta.footerId];
        oldSection = { ...footerComponent.content };
      } else if (
        component &&
        component.componentMeta &&
        component.componentMeta.blockType === "COVERPAGE"
      ) {
        const coverpageComponent =
          components[component.componentMeta.coverpageId];
        oldSection = { ...coverpageComponent.content };
      } else {
        oldSection = component;
      }
      this.props.updateActiveComponent({
        ...component,
        data: tableData,
      });
      if (
        newSection.clauseOptions &&
        this.props.mode === DOCUMENT_MODE.TEMPLATE
      ) {
        const { fieldsUsed } = this.props;
        newSection.clauseOptions.value = tableData;
        const currentTableFieldData = fieldsUsed.find(
          elem => elem.id === newSection.clauseOptions.id,
        );
        const {
          id,
          type,
          field_name: name,
          label,
          description,
          isTableFormField,
        } = currentTableFieldData;
        const tableField = {
          id,
          type,
          name,
          description,
          label,
          defaultValue: newSection ? newSection.data : {},
          isTableFormField: true,
        };

        updateClauseOptionsService(tableField);
      }
      updateSection(
        newSection,
        change,
        undefined,
        oldSection,
        false,
        undefined,
        true,
        this.props.activeComponentMeta,
      );
    }
  };

  _getComponent = () =>
    this.props.isSeparateToolbar
      ? this.props.activeComponent
      : this.props.section;

  _handleTableApiEdit = (
    focusRowID,
    tableAttributes,
    direction,
    type,
    action,
  ) => {
    const { isUnlinkedTableAPI, dataSource } = tableAttributes;
    if (dataSource !== "TableApi" || !isUnlinkedTableAPI) {
      return false;
    }
    if (type === "COL") {
      this.setState({
        currSection: this.props.component,
        currFocusColumnId: this.props.focusColumnID,
        currFocusRowId: this.props.focusRowID,
        showEditHeaderPopupTableApi: true,
        showEditHeaderPopupTableApiType: "ROW_COL",
        direction,
        action,
      });
      return true;
    }
    if (focusRowID === 0 && (direction === "U" || direction === null)) {
      this.setState({
        currSection: this.props.component,
        currFocusColumnId: this.props.focusColumnID,
        currFocusRowId: this.props.focusRowID,
        // currActiveMeta: this.props.activeComponentMeta,
        showEditHeaderPopupTableApi: true,
        showEditHeaderPopupTableApiType: "ROW_COL",
        direction,
        action,
      });
      return true;
    }
    return false;
  };

  _addTableApiRow = direction => {
    const { fieldsUsed } = this.props;
    const focusRowID =
      this.props.focusRowID === null || this.props.focusRowID === undefined
        ? this.state.currFocusRowId
        : this.props.focusRowID;
    const component = this.state.currSection || this.props.component;
    const { data: tableData, clauseOptions } = component;
    const { id: dynamicFieldId } = clauseOptions;
    const clauseField = fieldsUsed.find(field => field.id === dynamicFieldId);
    const { value: tableValue } = clauseField;
    const tableId = tableValue.unlinked_table_id
      ? tableValue.unlinked_table_id
      : tableValue.linked_table_id;
    let unlinkedTableData;
    this.props.tablesUsed.forEach(table => {
      if (table.table_id === tableId) {
        unlinkedTableData = table;
      }
    });
    let prevRowId;
    let insertRowAfter;
    if (focusRowID === 0) {
      prevRowId = "";
      insertRowAfter = focusRowID;
    } else if (direction === "U") {
      insertRowAfter = focusRowID - 1;
      prevRowId =
        insertRowAfter === 0
          ? ""
          : tableData.data[focusRowID - 1].attributes.id;
    } else if (direction === "D") {
      prevRowId = tableData.data[focusRowID].attributes.id;
      insertRowAfter = focusRowID;
    }
    this.props
      .tableAddRow(
        tableId,
        prevRowId,
        "insert-row",
        insertRowAfter,
        clauseField,
      )
      .then(() => {})
      .catch(error => {
        console.error("RevvTableToolbar => _addTableApiRow => Error", error);
      });
  };

  _addRow = (direction, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.props.nukeActiveEditor(true);

    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }

    const { focusColumnID } = this.props;
    const component = this.state.currSection || this.props.component;
    const { fieldsUsed } = this.props;
    const { data: tableData, clauseOptions } = component;
    const { data, attributes } = tableData;
    const focusRowID =
      this.props.focusRowID === null || this.props.focusRowID === undefined
        ? this.state.currFocusRowId
        : this.props.focusRowID;
    const { dataSource } = attributes;
    const { data: rowData, attributes: rowAttributes } = data[focusRowID];
    if (dataSource === "TableApi") {
      const { id: dynamicFieldId } = clauseOptions;
      const clauseField = fieldsUsed.find(field => field.id === dynamicFieldId);
      const { value: tableValue, tables } = clauseField;
      const tableId = tableValue.unlinked_table_id
        ? tableValue.unlinked_table_id
        : tableValue.linked_table_id;
      const { table_type: tableType } = tables[tableId];
      let showEditHeaderTableApi = false;
      if (tableType === "TABLE_API_DOCUMENT") {
        const actionType = "ROW";
        const action = "addRow";
        showEditHeaderTableApi = this._handleTableApiEdit(
          focusRowID,
          attributes,
          direction,
          actionType,
          action,
        );
        if (!showEditHeaderTableApi) this._addTableApiRow(direction);
      } else if (tableType === "TABLE_DOCUMENT") {
        this._addTableApiRow(direction);
      }
    } else {
      let newRowData = [];
      let newRow;
      if (rowAttributes.columnCount < attributes.columnCount) {
        for (let i = 0; i < attributes.columnCount; i += 1) {
          newRowData.push(this._emptyCell());
        }
        newRow = {
          attributes: {
            ...rowAttributes,
            id: uuid.v4(),
          },
          data: newRowData,
        };
      } else {
        newRowData = rowData.map(() => this._emptyCell());
        newRow = {
          attributes: {
            ...rowAttributes,
            id: uuid.v4(),
          },
          data: newRowData,
        };
      }

      let newData;
      let currFocusRowId;
      if (direction === "U") {
        // Add row above
        newData = data
          .slice(0, focusRowID)
          .concat(newRow, data.slice(focusRowID, data.length));
        currFocusRowId = focusRowID;
      } else if (direction === "D") {
        // Add row below
        newData = data
          .slice(0, focusRowID + 1)
          .concat(newRow, data.slice(focusRowID + 1, data.length));
        currFocusRowId = focusRowID + 1;
      }
      const updatedRowCount = attributes.rowCount + 1;
      const newTableData = {
        data: newData,
        attributes: { ...attributes, rowCount: updatedRowCount },
      };
      // This "activeCellID" is for clickedActiveComponentId
      let activeCellID = null;
      if (newRowData && newRowData.length > 0) {
        activeCellID =
          newRowData[focusColumnID] && newRowData[focusColumnID].attributes
            ? newRowData[focusColumnID].attributes.id
            : null;
      }
      this._saveTable(
        newTableData,
        activeCellID,
        currFocusRowId,
        focusColumnID,
      );
      this.props.coverpageThemeAction(null);
      // }
    }
    // if (!showEditHeaderTableApi) {
  };

  _removeRow = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.nukeActiveEditor(true);

    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
    // this._checkDropdownisOpen();
    const {
      focusRowID,
      focusColumnID,
      // tableData: { data, attributes },
    } = this.props;
    const {
      component: { data: tableData, clauseOptions },
      fieldsUsed,
    } = this.props;
    const { data, attributes } = tableData;
    const actionType = "ROW";
    const action = "removeRow";
    const showEditHeaderTableApi = this._handleTableApiEdit(
      focusRowID,
      attributes,
      null,
      actionType,
      action,
    );

    const { dataSource } = attributes;
    if (dataSource === "TableApi") {
      const { id: dynamicFieldId } = clauseOptions;
      const clauseField = fieldsUsed.find(field => field.id === dynamicFieldId);
      const { value: tableValue } = clauseField;
      const tableId = tableValue.unlinked_table_id
        ? tableValue.unlinked_table_id
        : tableValue.linked_table_id;
      let unlinkedTableData;
      this.props.tablesUsed.forEach(table => {
        if (table.table_id === tableId) {
          unlinkedTableData = table;
        }
      });
      const { table_type: tableType } = unlinkedTableData;
      if (tableType === "TABLE_DOCUMENT") {
        let prevRowId;
        let currRowId;
        let insertRowAfter;
        if (focusRowID === 0 || focusRowID === 1) {
          prevRowId = "";
          currRowId = tableData.data[focusRowID].attributes.id;
        } else {
          prevRowId = tableData.data[focusRowID - 1].attributes.id;
          currRowId = tableData.data[focusRowID].attributes.id;
        }
        const deleteRowAt = focusRowID;
        this.props
          .tableDeleteRow(
            tableId,
            prevRowId,
            currRowId,
            "rows",
            deleteRowAt,
            clauseField,
          )
          .then(() => {})
          .catch(error => {
            console.error("RevvTableToolbar => _removeRow => Error", error);
          });
      }
    } else if (Array.isArray(data) && data.length > 1) {
      const newData = data
        .slice(0, focusRowID)
        .concat(data.slice(focusRowID + 1, data.length));
      attributes.rowCount -= 1;
      const newTableData = { data: newData, attributes };

      // This "activeCellID" is for clickedActiveComponentId
      let activeCellID = null;
      let activeRowIndex = focusRowID;
      if (focusRowID === newData.length) {
        activeRowIndex = focusRowID - 1;
      }
      if (
        newData[activeRowIndex] &&
        newData[activeRowIndex].data &&
        newData[activeRowIndex].data.length > 0
      ) {
        const activeRow = newData[activeRowIndex].data;
        activeCellID =
          activeRow[focusColumnID] && activeRow[focusColumnID].attributes
            ? activeRow[focusColumnID].attributes.id
            : null;
      }
      this._saveTable(
        newTableData,
        activeCellID,
        activeRowIndex,
        focusColumnID,
      );
      // this._closeTableColorPicker();
    }
    this.props.coverpageThemeAction(null);
  };

  _checkForMergedCells = colID => {
    const {
      component: { data: tableData },
    } = this.props;
    const { data, attributes } = tableData;
    const clickedCell = data[0].data[0];
    if (
      Object.prototype.hasOwnProperty.call(clickedCell.attributes, "colspan")
    ) {
      const colspanVal = parseInt(clickedCell.attributes.colspan, 10);
      // example: 2,3,4 are the merged cells so making the colID for this merged
      // cell to be 2 but while adding a col to it's right the colID should be 4
      // colspan is 3, adding (3 - 1) to actual colID(2) gives the desired colID (4)
      const newColID = colID + (colspanVal - 1);
      return newColID;
    }
    return colID;
  };

  _rowMergeData = row => {
    const mergeData = {};
    row.some((cell, idx) => {
      if (isTableCellMerged(cell)) {
        mergeData.mergePosition = idx;
        const mergedCellsSpan = [];
        for (
          let i = idx;
          i < idx + parseInt(cell.attributes.colspan, 10);
          i += 1
        ) {
          mergedCellsSpan.push(i);
        }
        mergeData.mergeSpan = mergedCellsSpan;
        mergeData.mergeSpanLength = mergedCellsSpan.length;
        return true;
      }
      return false;
    });
    return mergeData;
  };

  _calculateEffectiveIndex = (row, focusColId) => {
    let effectiveId = -1;
    row.data.forEach((col, colId) => {
      if (colId <= focusColId) {
        if (isTableCellMerged(col)) {
          effectiveId += parseInt(col.attributes.colspan, 10);
        } else {
          effectiveId += 1;
        }
      }
    });
    return effectiveId;
  };

  _positionToAddCell = (row, dummyId, focusColumnID, columnCount) => {
    let posToAdd = focusColumnID;
    let effectiveId = 0;
    if (row.data.length < columnCount) {
      row.data.some((cell, colId) => {
        if (isTableCellMerged(cell)) {
          effectiveId += parseInt(cell.attributes.colspan, 10) - 1;
        } else {
          effectiveId += 1;
        }
        if (effectiveId === dummyId) {
          posToAdd = colId;
          return true;
        }
        if (effectiveId > dummyId) {
          posToAdd = colId;
          return true;
        }
        return false;
      });
      return posToAdd;
    }
    return dummyId;
  };

  _addTableApiColumn = direction => {
    const { fieldsUsed } = this.props;
    const focusColumnID =
      this.props.focusColumnID === null ||
      this.props.focusColumnID === undefined
        ? this.state.currFocusColumnId
        : this.props.focusColumnID;
    const component = this.state.currSection || this.props.component;
    const { data: tableData, clauseOptions } = component;
    const { id: dynamicFieldId } = clauseOptions;
    const clauseField = fieldsUsed.find(field => field.id === dynamicFieldId);
    const { value: tableValue, tables } = clauseField;
    const tableId = tableValue.unlinked_table_id
      ? tableValue.unlinked_table_id
      : tableValue.linked_table_id;
    let unlinkedTableData;
    this.props.tablesUsed.forEach(table => {
      if (table.table_id === tableId) {
        unlinkedTableData = table;
      }
    });
    const {
      column_order: columnOrder,
      table_type: tableType,
      table_meta: tableMeta,
    } = unlinkedTableData;
    let prevId;
    let insertColAt;
    if (direction === "L") {
      if (focusColumnID === 0) {
        prevId = "";
        insertColAt = focusColumnID;
      } else {
        prevId = columnOrder[focusColumnID - 1];
        insertColAt = focusColumnID;
      }
    } else if (direction === "R") {
      prevId = columnOrder[focusColumnID];
      insertColAt = focusColumnID + 1;
    }
    let columnWidths = [];
    if (tableMeta && tableMeta.columnWidth) {
      columnWidths = [
        ...tableMeta.columnWidth.slice(0, insertColAt + 1),
        "100px",
        ...tableMeta.columnWidth.slice(insertColAt + 1),
      ];
    } else {
      columnWidths = Array(columnOrder.length + 1).fill("100px");
    }
    const updatedTableMeta = { columnWidth: columnWidths };
    this.props
      .tableAddCol(tableId, prevId, "insert-col", insertColAt, clauseField)
      .then(() => {
        this.props.tableMetaUpdate(
          tableId,
          "table-meta",
          updatedTableMeta,
          dynamicFieldId,
        );
      })
      .catch(error => {
        console.error("RevvTableToolbar => _addTableApiColumn => Error", error);
      });
  };

  _addColumn = (direction, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.props.nukeActiveEditor(true);

    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }

    // this._checkDropdownisOpen();
    const {
      focusRowID,
      // focusColumnID,
      // tableData: { data, attributes },
    } = this.props;
    const component = this.state.currSection || this.props.component;
    const {
      // component: { data: tableData, clauseOptions },
      fieldsUsed,
    } = this.props;
    const focusColumnID =
      this.props.focusColumnID === null ||
      this.props.focusColumnID === undefined
        ? this.state.currFocusColumnId
        : this.props.focusColumnID;
    const { data: tableData, clauseOptions } = component;
    const clonedTableData = cloneDeep(tableData);
    const { data, attributes } = clonedTableData;
    const { tableColumnDefs, columnCount } = attributes;

    const { dataSource } = attributes;
    let effectiveFocusColId = focusColumnID;
    if (dataSource === "TableApi") {
      const { id: dynamicFieldId } = clauseOptions;
      const clauseField = fieldsUsed.find(field => field.id === dynamicFieldId);
      const { value: tableValue, tables } = clauseField;
      const tableId = tableValue.unlinked_table_id
        ? tableValue.unlinked_table_id
        : tableValue.linked_table_id;
      const { table_type: tableType } = tables[tableId];
      let showEditHeaderTableApi = false;
      if (tableType === "TABLE_API_DOCUMENT") {
        const actionType = "COL";
        const action = "addCol";
        showEditHeaderTableApi = this._handleTableApiEdit(
          focusRowID,
          attributes,
          direction,
          actionType,
          action,
        );
        if (!showEditHeaderTableApi) this._addTableApiColumn(direction);
      } else if (tableType === "TABLE_DOCUMENT") {
        this._addTableApiColumn(direction);
      }
    } else {
      const focusRowHasMergeCells = data[focusRowID].data.length < columnCount;
      const focusRowMergeData = focusRowHasMergeCells
        ? this._rowMergeData(data[focusRowID].data)
        : null;
      const effectiveId = this._calculateEffectiveIndex(
        data[focusRowID],
        focusColumnID,
      );
      // let addedColumn = null;
      const newData = data.map((row, rowId) => {
        const posToAddCell = this._positionToAddCell(
          row,
          effectiveId,
          focusColumnID,
          columnCount,
        );
        effectiveFocusColId = focusColumnID;
        // To handle the cases added from merge cell
        if (direction === "R") {
          if (isTableCellMerged(data[focusRowID].data[focusColumnID])) {
            effectiveFocusColId =
              focusColumnID +
              parseInt(
                data[focusRowID].data[focusColumnID].attributes.colspan,
                10,
              ) -
              1;
          }
        }
        // To handle the right side of merge cell cases
        if (
          focusRowHasMergeCells &&
          !isTableCellMerged(data[focusRowID].data[focusColumnID]) &&
          focusColumnID > focusRowMergeData.mergePosition
        ) {
          const { mergeSpanLength, mergePosition } = focusRowMergeData;
          effectiveFocusColId = focusColumnID + mergeSpanLength - 1;
        }
        const { data: rData } = row;
        // merge-cell flow
        // row has less cells than colCount implies that row has merged cells
        if (rData.length < columnCount) {
          effectiveFocusColId = focusColumnID;
          let mergedCellID = null;
          rData.some((cell, idx) => {
            const mergedCellsSpan = [];
            for (
              let i = idx;
              i < idx + parseInt(cell.attributes.colspan, 10);
              i += 1
            ) {
              mergedCellsSpan.push(i);
            }

            // for handling span cases and calulating mergedCellID
            if (
              isTableCellMerged(cell) &&
              mergedCellsSpan.includes(focusColumnID) &&
              ((direction === "L" && focusColumnID !== mergedCellsSpan[0]) ||
                (direction === "R" &&
                  focusColumnID !==
                    mergedCellsSpan[mergedCellsSpan.length - 1])) &&
              rowId !== focusRowID
            ) {
              mergedCellID = idx;
              return true;
            }
            // To handle add column from other than focusRow === merge row and
            // focusCell should be on the right of merge cell
            if (
              isTableCellMerged(cell) &&
              focusColumnID >=
                mergedCellsSpan[mergedCellsSpan.length - 1] - 1 &&
              !focusRowHasMergeCells
            ) {
              effectiveFocusColId = focusColumnID - mergedCellsSpan.length + 1;
              return true;
            }
            return false;
          });

          // for handling span cases
          if (mergedCellID !== null) {
            rData[mergedCellID].attributes.colspan = (
              parseInt(rData[mergedCellID].attributes.colspan, 10) + 1
            ).toString();
            row.data = rData;
            return row;
          }
        }
        if (direction === "R") {
          effectiveFocusColId = posToAddCell;
          // Add col on right
          row.data = [
            ...rData.slice(0, effectiveFocusColId + 1),
            this._emptyCell(),
            ...rData.slice(effectiveFocusColId + 1),
          ];
        } else if (direction === "L") {
          // Add col on left
          row.data = [
            ...rData.slice(0, effectiveFocusColId),
            this._emptyCell(),
            ...rData.slice(effectiveFocusColId),
          ];
        }
        row.attributes.columnCount += 1;
        return row;
      });

      attributes.columnCount += 1;
      const colWidth = [...attributes.columnWidth];
      let currFocusColId;
      if (direction === "R") {
        if (isTableCellMerged(data[focusRowID].data[focusColumnID])) {
          effectiveFocusColId =
            focusColumnID +
            parseInt(
              data[focusRowID].data[focusColumnID].attributes.colspan,
              10,
            ) -
            1;
        }
        // Add col on right
        attributes.columnWidth = [
          ...colWidth.slice(0, effectiveFocusColId + 1),
          "100px",
          ...colWidth.slice(effectiveFocusColId + 1),
        ];
        currFocusColId = effectiveFocusColId + 1;
      } else if (direction === "L") {
        // Add col on left
        attributes.columnWidth = [
          ...colWidth.slice(0, effectiveFocusColId),
          "100px",
          ...colWidth.slice(effectiveFocusColId),
        ];
        currFocusColId = effectiveFocusColId;
      }

      // Updating column id's in columnDefs
      if (tableColumnDefs && tableColumnDefs.length > 0) {
        const newCol = { id: uuid.v4() };
        if (direction === "R") {
          tableColumnDefs.splice(focusColumnID + 1, 0, newCol);
          currFocusColId = focusColumnID + 1;
        } else if (direction === "L") {
          tableColumnDefs.splice(focusColumnID, 0, newCol);
          currFocusColId = focusColumnID;
        }
      }
      attributes.tableColumnDefs = tableColumnDefs;
      const newTableData = { data: newData, attributes };

      // This "activeCellID" is for clickedActiveComponentId
      let activeCellID = null;
      if (
        newData[focusRowID] &&
        newData[focusRowID].data &&
        newData[focusRowID].data.length > 0
      ) {
        const activeRow = newData[focusRowID].data;
        const activeColumnIndex =
          direction === "R" ? focusColumnID + 1 : focusColumnID;
        activeCellID =
          activeRow[activeColumnIndex] &&
          activeRow[activeColumnIndex].attributes
            ? activeRow[activeColumnIndex].attributes.id
            : null;
      }
      this._saveTable(newTableData, activeCellID, focusRowID, currFocusColId);
      this.props.coverpageThemeAction(null);
      // this._closeTableColorPicker();
    }
  };

  _removeTableApiColumn = () => {
    const { fieldsUsed } = this.props;
    const focusColumnID =
      this.props.focusColumnID === null ||
      this.props.focusColumnID === undefined
        ? this.state.currFocusColumnId
        : this.props.focusColumnID;
    const component = this.state.currSection || this.props.component;
    const { data: tableData, clauseOptions } = component;
    const { id: dynamicFieldId } = clauseOptions;
    const clauseField = fieldsUsed.find(field => field.id === dynamicFieldId);
    const { value: tableValue, tables } = clauseField;
    const tableId = tableValue.unlinked_table_id
      ? tableValue.unlinked_table_id
      : tableValue.linked_table_id;
    let unlinkedTableData;
    this.props.tablesUsed.forEach(table => {
      if (table.table_id === tableId) {
        unlinkedTableData = table;
      }
    });
    const {
      column_order: columnOrder,
      table_type: tableType,
      table_meta: tableMeta,
    } = unlinkedTableData;
    const currId = columnOrder[focusColumnID];
    let columnWidths = [];
    if (tableMeta && tableMeta.columnWidth) {
      columnWidths = [
        ...tableMeta.columnWidth
          .slice(0, focusColumnID)
          .concat(
            tableMeta.columnWidth.slice(
              focusColumnID + 1,
              tableMeta.columnWidth.length,
            ),
          ),
      ];
    } else {
      columnWidths = Array(columnOrder.length - 1).fill("100px");
    }
    const updatedTableMeta = { columnWidth: columnWidths };
    this.props
      .tableDeleteCol(tableId, currId, "cols", clauseField)
      .then(() => {
        this.props.tableMetaUpdate(
          tableId,
          "table-meta",
          updatedTableMeta,
          dynamicFieldId,
        );
      })
      .catch(error => {
        console.error("RevvTableTollbar => _removeColumn => Error", error);
      });
  };

  _removeColumn = event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.props.nukeActiveEditor(true);

    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }

    // this._checkDropdownisOpen();
    const {
      focusRowID,
      // focusColumnID,
      // tableData: { data, attributes },
    } = this.props;
    const component = this.state.currSection || this.props.component;
    const {
      // component: { data: tableData, clauseOptions },
      fieldsUsed,
    } = this.props;
    const { data: tableData, clauseOptions } = component;
    // const tempTableData = cloneDeep(tableData);
    const clonedTableData = cloneDeep(tableData);
    const { data, attributes } = clonedTableData;
    const focusColumnID =
      this.props.focusColumnID === null ||
      this.props.focusColumnID === undefined
        ? this.state.currFocusColumnId
        : this.props.focusColumnID;
    let effectiveFocusColumnID = focusColumnID;
    const { tableColumnDefs, columnCount } = attributes;
    const { dataSource } = attributes;
    if (dataSource === "TableApi") {
      const { id: dynamicFieldId } = clauseOptions;
      const clauseField = fieldsUsed.find(field => field.id === dynamicFieldId);
      const { value: tableValue, tables } = clauseField;
      const tableId = tableValue.unlinked_table_id
        ? tableValue.unlinked_table_id
        : tableValue.linked_table_id;
      let unlinkedTableData;
      this.props.tablesUsed.forEach(table => {
        if (table.table_id === tableId) {
          unlinkedTableData = table;
        }
      });
      const { column_order: columnOrder } = unlinkedTableData;
      const { table_type: tableType } = tables[tableId];
      let showEditHeaderTableApi = false;
      if (tableType === "TABLE_API_DOCUMENT") {
        const actionType = "COL";
        const action = "removeCol";
        showEditHeaderTableApi = this._handleTableApiEdit(
          focusRowID,
          attributes,
          null,
          actionType,
          action,
        );
        if (!showEditHeaderTableApi) this._removeTableApiColumn();
      } else if (tableType === "TABLE_DOCUMENT") {
        this._removeTableApiColumn();
      }
    } else {
      if (tableColumnDefs && tableColumnDefs.length > 0)
        tableColumnDefs.splice(effectiveFocusColumnID, 1);

      const focusRowHasMergeCells = data[focusRowID].data.length < columnCount;
      const focusRowMergeData = focusRowHasMergeCells
        ? this._rowMergeData(data[focusRowID].data)
        : null;

      const newData = data.map(row => {
        effectiveFocusColumnID = focusColumnID;

        // To handle the right side of merge cell cases
        if (
          focusRowHasMergeCells &&
          !isTableCellMerged(data[focusRowID].data[focusColumnID]) &&
          focusColumnID > focusRowMergeData.mergePosition
        ) {
          const { mergeSpanLength, mergePosition } = focusRowMergeData;
          effectiveFocusColumnID = focusColumnID + mergeSpanLength - 1;
        }
        const { data: rowData } = row;
        // merge-cell flow
        // row has less cells than colCount implies that row has merged cells
        if (rowData.length < columnCount) {
          effectiveFocusColumnID = focusColumnID;
          let returnRowData = false;
          let cellPosition;
          rowData.some((cell, idx) => {
            const colSpanVal = parseInt(cell.attributes.colspan, 10);
            if (isTableCellMerged(cell)) {
              if (effectiveFocusColumnID < idx) {
                return true;
              }
              if (
                (effectiveFocusColumnID === idx ||
                  effectiveFocusColumnID < idx + colSpanVal) &&
                !focusRowHasMergeCells
              ) {
                if (effectiveFocusColumnID === idx) {
                  rowData[idx].data = {
                    ...emptyTextEditor(undefined, undefined, true),
                  };
                }
                rowData[idx].attributes.colspan = (colSpanVal - 1).toString();
                returnRowData = true;
                return true;
              }
              if (effectiveFocusColumnID === idx && focusRowHasMergeCells) {
                rowData[idx].data = {
                  ...emptyTextEditor(undefined, undefined, true),
                };
                rowData[idx].attributes.colspan = (colSpanVal - 1).toString();
                returnRowData = true;
                return true;
              }
              if (!focusRowHasMergeCells && effectiveFocusColumnID > idx) {
                effectiveFocusColumnID -= colSpanVal - 1;
                return true;
              }
            }
            return false;
          });
          if (returnRowData) {
            return { ...row, data: rowData };
          }
        }
        const newRowData = row.data
          .slice(0, effectiveFocusColumnID)
          .concat(row.data.slice(effectiveFocusColumnID + 1, row.data.length));
        row.attributes.columnCount -= 1;
        return { ...row, data: newRowData };
      });
      attributes.columnCount -= 1;
      attributes.columnWidth = attributes.columnWidth
        .slice(0, effectiveFocusColumnID)
        .concat(
          attributes.columnWidth.slice(
            effectiveFocusColumnID + 1,
            attributes.columnWidth.length,
          ),
        );
      attributes.tableColumnDefs = tableColumnDefs;
      const newTableData = { data: newData, attributes };

      // This "activeCellID" is for clickedActiveComponentId
      let activeCellID = null;
      let activeColumnIndex;
      if (
        newData[focusRowID] &&
        newData[focusRowID].data &&
        newData[focusRowID].data.length > 0
      ) {
        activeColumnIndex = effectiveFocusColumnID;
        if (effectiveFocusColumnID === newData[focusRowID].data.length) {
          activeColumnIndex = effectiveFocusColumnID - 1;
        }
        const activeRow = newData[focusRowID].data;
        activeCellID =
          activeRow[activeColumnIndex] &&
          activeRow[activeColumnIndex].attributes
            ? activeRow[activeColumnIndex].attributes.id
            : null;
      }
      this._saveTable(
        newTableData,
        activeCellID,
        focusRowID,
        activeColumnIndex,
      );
      this.props.coverpageThemeAction(null);
      // this._closeTableColorPicker();
    }
  };

  _applyBackgroundColorForTableAPI = (
    bgColour,
    activeComponentMeta,
    component,
    activeCell,
    selectedIndex,
    selectedType,
    cellSelections,
    editorState,
    isTableAPIHeaderCellBgColourChange,
  ) => {
    const { fieldsUsed } = this.props;
    let updatedRow;
    const { data: tableData, clauseOptions } = component;
    const { tableRowId } = activeComponentMeta;
    const clonedTableData = cloneDeep(tableData);

    const { data: clonedData, attributes } = clonedTableData;

    const { dataSource, isUnlinkedTableAPI, isUnlinkedTableDocument } =
      attributes;

    const { id: dynamicFieldId } = clauseOptions;
    const clauseField = fieldsUsed.find(field => field.id === dynamicFieldId);
    const { value: tableValue, tables } = clauseField;
    const tableId = tableValue.unlinked_table_id
      ? tableValue.unlinked_table_id
      : tableValue.linked_table_id;
    let unlinkedTableData;
    this.props.tablesUsed.forEach(table => {
      if (table.table_id === tableId) {
        unlinkedTableData = table;
      }
    });
    const {
      table_rows: tableRows,
      column_order: columnOrder,
      table_schema: tableSchema,
    } = unlinkedTableData;
    const { label_map: labelMap } = tableSchema;
    if (activeCell !== null && !selectedType) {
      if (
        cellSelections &&
        cellSelections.cols &&
        cellSelections.cols.length > 0 &&
        cellSelections.rows &&
        cellSelections.rows.length > 0
      ) {
        // This is for multiple cell update (batch update)
        const updatedTableCells = [];
        tableRows.forEach((tableRow, idx) => {
          if (
            cellSelections.rows[0] - 1 >= 0 &&
            cellSelections.rows[0] - 1 === idx
          ) {
            cellSelections.cols.forEach(colIdx => {
              const rowObj = {};
              rowObj.row_id = tableRow.row_id;
              rowObj.row_data = {
                [columnOrder[colIdx]]: {
                  ...tableRow.row_data[columnOrder[colIdx]],
                  cell_meta: { bgColor: bgColour },
                },
              };
              updatedTableCells.push(rowObj);
            });
          }
        });
        this.props.tableBatchCellsUpdate(
          tableId,
          "batch-cells",
          updatedTableCells,
          dynamicFieldId,
        );
      } else {
        const { tableCellId } = activeComponentMeta;
        const [rowId, cellId] = tableCellId
          ? tableCellId.split("_")
          : [null, null];
        let cellData = {};
        if (isUnlinkedTableAPI && tableRowId === 0) {
          cellData = labelMap[rowId];
        } else {
          tableRows.forEach(tableRow => {
            if (tableRow.row_id === rowId) {
              cellData = tableRow.row_data[cellId];
            }
          });
        }
        let { cell_meta: cellMeta } = cellData;
        const { text, rich } = cellData;
        cellMeta = { ...cellMeta, bgColor: bgColour };
        this.props.saveUnlinkedTableAPICellData(
          editorState,
          cellMeta,
          text,
          rich,
          component,
          activeComponentMeta,
          isTableAPIHeaderCellBgColourChange,
        );
      }
    } else if (
      selectedType === "COLUMN" &&
      !isTableAPIHeaderCellBgColourChange
    ) {
      // This is for column update (batch update)
      const updatedTableCells = [];
      tableRows.forEach(tableRow => {
        const rowObj = {};
        rowObj.row_id = tableRow.row_id;
        rowObj.row_data = {
          [columnOrder[selectedIndex]]: {
            ...tableRow.row_data[columnOrder[selectedIndex]],
            cell_meta: { bgColor: bgColour },
          },
        };
        updatedTableCells.push(rowObj);
      });
      this.props.tableBatchCellsUpdate(
        tableId,
        "batch-cells",
        updatedTableCells,
        dynamicFieldId,
      );
    } else if (selectedType === "ROW" && !isTableAPIHeaderCellBgColourChange) {
      if (selectedIndex >= 1) {
        updatedRow = tableRows[selectedIndex - 1];
        const updateRowAt = selectedIndex - 1;
        const { row_data: rowData } = updatedRow;
        Object.keys(rowData).forEach(row => {
          rowData[row].cell_meta = { bgColor: bgColour };
        });
        updatedRow.row_data = rowData;
        this.props
          .tableRowUpdate(tableId, "rows", updatedRow, updateRowAt, clauseField)
          .then(() => {})
          .catch(error => {
            console.error(
              "RevvTableToolbar => _applyBackgroundColor => Error",
              error,
            );
          });
      }
    }

    this.setState({
      colorSelected: bgColour,
    });

    this.props.preventEditorToDeactivate(false);
    this.props.updateComponentMeta({
      ...activeComponentMeta,
      cellSelection: null,
    });
  };

  _applyBackgroundColor = event => {
    const {
      component: { data: tableData, clauseOptions },
      activeCell,
      selectedIndex,
      selectedType,
      cellSelections,
      fieldsUsed,
    } = this.props;

    const clonedTableData = cloneDeep(tableData);

    const { data: clonedData, attributes } = clonedTableData;

    let change = false;

    const { dataSource, isUnlinkedTableAPI, isUnlinkedTableDocument } =
      attributes;
    let updatedRow;
    if (dataSource === "TableApi") {
      const editorState = this.props.getEditorState();
      const { tableRowId } = this.props.activeComponentMeta;
      if (!isUnlinkedTableDocument && tableRowId === 0 && isUnlinkedTableAPI) {
        this.props.preventEditorToDeactivate(false);
        this.setState({
          showEditHeaderPopupTableApi: true,
          showEditHeaderPopupTableApiType: "BG_COLOUR",
          tableAPIHeaderSelectedBgColor: event.hex,
          currSection: this.props.component,
          currComponentMeta: this.props.activeComponentMeta,
          currFocusColumnId: this.props.focusColumnID,
          currFocusRowId: this.props.focusRowID,
          currTableAPIActiveCell: activeCell,
          currTableAPISelectedIndex: selectedIndex,
          currTableAPIselectedType: selectedType,
          currTableAPICellSelections: cellSelections,
          currTablePIEditorState: editorState,
        });
      } else {
        this._applyBackgroundColorForTableAPI(
          event.hex,
          this.props.activeComponentMeta,
          this.props.component,
          activeCell,
          selectedIndex,
          selectedType,
          cellSelections,
          editorState,
        );
      }
    } else {
      if (activeCell !== null && !selectedType) {
        if (
          cellSelections &&
          cellSelections.cols &&
          cellSelections.cols.length > 0 &&
          cellSelections.rows &&
          cellSelections.rows.length > 0
        ) {
          const sortedIndex = cellSelections.cols;
          const selectionRange = range(sortedIndex[0], sortedIndex[1] + 1);
          clonedData[cellSelections.rows[0]].data.forEach((dt, idx) => {
            if (selectionRange.includes(idx)) {
              change = dt.attributes.bgColor !== event.hex;
              dt.attributes.bgColor = event.hex;
            }
          });
        } else {
          change =
            clonedData[activeCell[0]].data[activeCell[1]].attributes.bgColor !==
            event.hex;
          clonedData[activeCell[0]].data[activeCell[1]].attributes.bgColor =
            event.hex;
        }
      } else if (selectedType === "COLUMN") {
        clonedData.forEach(row => {
          // merge-cell flow
          let effectiveSelectedIndex = selectedIndex;
          let applyColorForMergeCell = false;
          if (row.data.length < attributes.columnCount) {
            row.data.some((cell, idx) => {
              if (isTableCellMerged(cell)) {
                // Enter only if selected cell is in range and right of merge
                if (idx <= selectedIndex) {
                  const mergePos = idx;
                  const colspanVal = parseInt(cell.attributes.colspan, 10);
                  // Apply bg color for merge cell
                  if (selectedIndex === mergePos) {
                    change =
                      row.data[effectiveSelectedIndex].attributes.bgColor !==
                      event.hex;
                    row.data[effectiveSelectedIndex].attributes.bgColor =
                      event.hex;
                    return true;
                  }
                  // For ignoring indexes in range of merge cell
                  if (selectedIndex < mergePos + colspanVal) {
                    applyColorForMergeCell = true;
                    return true;
                  }
                  // Changing effectiveSelectedIndex for cells right of merge cell
                  if (selectedIndex >= mergePos + colspanVal) {
                    effectiveSelectedIndex -= colspanVal - 1;
                    return true;
                  }
                }
              }
              return false;
            });
          }
          // Apply Bgcolor for non merge cell and in applicable cells
          if (
            !applyColorForMergeCell &&
            !isTableCellMerged(row.data[effectiveSelectedIndex])
          ) {
            change =
              row.data[effectiveSelectedIndex].attributes.bgColor !== event.hex;
            row.data[effectiveSelectedIndex].attributes.bgColor = event.hex;
          }
        });
      } else if (selectedType === "ROW") {
        clonedData[selectedIndex].data.forEach(dt => {
          change = dt.attributes.bgColor !== event.hex;
          dt.attributes.bgColor = event.hex;
        });
      }

      this.setState({
        colorSelected: event.hex,
      });

      const updatedTableData = {
        data: [...clonedData],
        attributes: {
          ...attributes,
        },
      };

      if (change)
        this._saveTableData(
          updatedTableData,
          this.props.focusRowID,
          this.props.focusColumnID,
          change,
        );

      this.props.preventEditorToDeactivate(false);
      this.props.updateComponentMeta({
        ...this.props.activeComponentMeta,
        cellSelection: null,
      });
    }
  };

  _confirmEditTableAPIHeader = activeComponentMeta => {
    if (this.state.showEditHeaderPopupTableApiType === "BG_COLOUR") {
      this._applyBackgroundColorForTableAPI(
        this.state.tableAPIHeaderSelectedBgColor,
        this.state.currComponentMeta,
        this.state.currSection,
        this.state.currTableAPIActiveCell,
        this.state.currTableAPISelectedIndex,
        this.state.currTableAPIselectedType,
        this.state.currTableAPICellSelections,
        this.state.currTablePIEditorState,
        true,
      );
      this.setState({
        tableAPIHeaderSelectedBgColor: "",
        showEditHeaderPopupTableApiType: "",
        currTableAPIActiveCell: null,
        currTableAPISelectedIndex: null,
        currTableAPIselectedType: null,
        currTableAPICellSelections: null,
        currTablePIEditorState: null,
        currSection: null,
        currComponentMeta: null,
      });
      this.props.updateComponentMeta({
        ...activeComponentMeta,
      });
    } else {
      this.props.updateComponentMeta({
        ...activeComponentMeta,
        tableCellEditMode: true,
      });
      this.setState({
        currSection: null,
      });
    }

    this.props.updateDocumentClickedComponentID(
      activeComponentMeta.tableCellId,
      true,
      activeComponentMeta.componentType,
    );
  };

  // _mergeCells = () => {
  //   const {
  //     component: { data: tableData },
  //     activeCell,
  //     selectedIndex,
  //     selectedType,
  //   } = this.props;

  //   const clonedTableData = cloneDeep(tableData);
  //   const { data: clonedData, attributes } = clonedTableData;
  //   const activeCellData = clonedData[activeCell[0]].data[activeCell[1]];
  //   if (isTableCellMerged(activeCellData) && !selectedIndex && !selectedType) {
  //     const colSpanVal = parseInt(activeCellData.attributes.colspan, 10);
  //     const newCell = { ...activeCellData };
  //     delete newCell.attributes.colspan;
  //     const newCells = [];
  //     newCells.push(newCell);
  //     for (let i = 0; i < colSpanVal - 1; i += 1) {
  //       newCells.push(this._emptyCell());
  //     }
  //     const currentRowData = clonedData[activeCell[0]].data;

  //     const newRowData = [
  //       ...currentRowData.slice(0, activeCell[1]),
  //       ...newCells,
  //       ...currentRowData.slice(activeCell[1] + 1),
  //     ];
  //     clonedData[activeCell[0]].data = newRowData;
  //     const updatedTableData = {
  //       data: [...clonedData],
  //       attributes: {
  //         ...attributes,
  //       },
  //     };
  //     this._saveTableData(
  //       updatedTableData,
  //       this.props.focusRowID,
  //       this.props.focusColumnID,
  //       true,
  //     );
  //     this.props.preventEditorToDeactivate(false);
  //   } else {
  //     const selectedRowData = clonedData[selectedIndex];
  //     const mergeStartID = 0;
  //     const mergeEndID = attributes.columnCount - 1;
  //     // remove hardcoded 0 index below
  //     selectedRowData.data = [selectedRowData.data[0]];
  //     selectedRowData.data[0].attributes.colspan = attributes.columnCount.toString();

  //     const updatedTableData = {
  //       data: [...clonedData],
  //       attributes: {
  //         ...attributes,
  //       },
  //     };

  //     this._saveTableData(
  //       updatedTableData,
  //       this.props.focusRowID,
  //       this.props.focusColumnID,
  //       true,
  //     );

  //     this.props.preventEditorToDeactivate(false);
  //   }
  // };

  _applyBorderColor = event => {
    const {
      component: { data: tableData, clauseOptions },
      focusRowID,
      focusColumnID,
    } = this.props;
    const { dataSource, tableAPIFieldId } = tableData.attributes;

    if (dataSource === "TableApi") {
      const { id: dynamicFieldId } = clauseOptions;
      const updatedTableMeta = { borderColor: event.hex };
      this.props.tableMetaUpdate(
        tableAPIFieldId,
        "table-meta",
        updatedTableMeta,
        dynamicFieldId,
      );
      this.setState({
        colorSelected: event.hex,
      });
    } else {
      const attributesClone = cloneDeep(tableData.attributes);
      let change = false;
      change = attributesClone.borderColor !== event.hex;
      attributesClone.borderColor = event.hex;

      this.setState({
        colorSelected: event.hex,
      });

      const updatedTableData = {
        data: tableData.data,
        attributes: {
          ...attributesClone,
        },
      };

      this._saveTableData(updatedTableData, focusRowID, focusColumnID, change);

      this.props.preventEditorToDeactivate(false);
    }
  };

  _toogleToolbarDropDown = type => {
    this.setState({
      activeToolbarDropDown: type,
    });
  };

  _decideMergeState = () => {
    const {
      component: { data: tableData },
      activeCell,
      selectedIndex,
      selectedType,
      activeComponentMeta: { cellSelection },
    } = this.props;
    const {
      attributes: { dataSource },
    } = tableData;
    if (dataSource === "TableApi") {
      return "disabled";
    }
    if (cellSelection) {
      return "merge";
    }
    let state = "disabled";
    // state values: ["disabled", "merge", "unmerge"]
    if (selectedType === "COLUMN") {
      state = "disabled";
    }
    if (selectedType === "ROW") {
      state = "merge";
      if (
        (selectedIndex !== undefined || selectedIndex !== null) &&
        tableData &&
        tableData.data &&
        tableData.data[selectedIndex].data.length === 1
      ) {
        state = "unmerge";
      }
      if (tableData && tableData.attributes.columnCount === 1) {
        state = "disabled";
      }
    }
    if (
      !selectedType &&
      Array.isArray(activeCell) &&
      activeCell.length === 2 &&
      tableData &&
      isTableCellMerged(tableData.data[activeCell[0]].data[activeCell[1]])
    ) {
      state = "unmerge";
    }
    return state;
  };

  render() {
    let hideToolbarForLinkedTable = true;
    const { clickedActiveComponentId, fieldsUsed, focusColumnID, focusRowID } =
      this.props;
    const component = this._getComponent();
    const { showEditHeaderPopupTableApi } = this.state;
    let showEditTableApiHeader = null;
    const activeComponent = this.props.activeComponentMeta;

    if (showEditHeaderPopupTableApi) {
      showEditTableApiHeader = (
        <EditTableApiHeaderPopup
          closePopup={() => {
            this.props.updateComponentMeta(this.props.activeComponentMeta);
            this.setState({
              showEditHeaderPopupTableApi: false,
            });
          }}
          onConfirm={this._confirmEditTableAPIHeader}
          header="Are you sure you want edit header row?"
          subHeader={
            "Editing header row might cause some issues in downstream actions. Incase you want to restore the data, click on the restore button in the dropdown."
          }
          checkboxLabel="Yes, I want to edit header row"
          okBtnText="Edit header"
          component={this.state.currSection}
          fieldsUsed={fieldsUsed}
          focusColumnID={focusColumnID}
          focusRowID={focusRowID}
          direction={this.state.direction}
          action={this.state.action}
          addTableApiRow={this._addTableApiRow}
          addTableApiColumn={this._addTableApiColumn}
          removeTableApiColumn={this._removeTableApiColumn}
          componentMeta={{ ...this.props.activeComponentMeta }}
        />
      );
    }
    if (
      this.props.showForm &&
      component &&
      component.data &&
      component.data.attributes &&
      !component.data.attributes.editable
    ) {
      hideToolbarForLinkedTable = false;
    }
    return (
      <Fragment>
        {showEditTableApiHeader}

        {
          clickedActiveComponentId &&
            component &&
            component.type === "Table" && (
              // return (
              <Fragment>
                {/* ---------- Manage Column Popup section ---------- */}
                {this.state.showManageColumnPopup && (
                  <ManageColumnsPopup
                    show={this.state.showManageColumnPopup}
                    closePopup={() =>
                      this.setState({ showManageColumnPopup: false })
                    }
                    columns={this.state.columnsHeaders}
                    setMngColsData={this._setMngColsData}
                    hiddenCols={this.state.hiddenColumnsForGsheet}
                  />
                )}

                {/* ---------- Table options section ---------- */}
                {this._showOrHideToolBar(component) && (
                  <div
                    className={`revvtoolbar-table-wrapper ${
                      this.props.isEditableTablePlaceholderComponent &&
                      this.props.showForm
                        ? "center-aligned-tabletoolbar"
                        : ""
                    }`}>
                    <span className="revvtabletoolbar-btn-title">
                      Table Menu
                    </span>
                    {this._showOrHideColorBtn(component) && (
                      <ColorOptionBtns
                        data-test="revvtoolbar-header-buttons"
                        editorState={this.props.editorState}
                        component={component}
                        applyBackgroundColor={this._applyBackgroundColor}
                        applyBorderColor={this._applyBorderColor}
                        section={this.props.section}
                        colorSelected={this.state.colorSelected}
                        toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                        showBackgroundColorDropdown={
                          this.props.activeToolbarDropDown ===
                          "BACKGROUND_COLOR"
                        }
                        showBorderColorDropdown={
                          this.props.activeToolbarDropDown === "BORDER_COLOR"
                        }
                        toggleDropdown={this._toggleDropdown}
                        saveTableData={this._saveTableData}
                        activeToolbarDropDown={this.props.activeToolbarDropDown}
                        saveTable={this._saveTable}
                      />
                    )}
                    <div className="line-divide" />
                    {this._showOrHideRowColBtn(component) && (
                      <span className="revvtabletoolbar-btn-title margin-left">
                        Column Options
                      </span>
                    )}
                    {this._showOrHideRowColBtn(component) && (
                      <ColumnOptionBtns
                        editorState={this.props.editorState}
                        toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                        addColumn={this._addColumn}
                        removeColumn={this._removeColumn}
                        activeToolbarDropDown={this.props.activeToolbarDropDown}
                        metaData={this.props.metaData}
                        component={component}
                        saveMetaData={this.props.saveMetaData}
                        saveTable={this._saveTable}
                      />
                    )}
                    {this._showOrHideRowColBtn(component) && (
                      <div className="line-divide" />
                    )}

                    {this._showOrHideRowColBtn(component) && (
                      <span className="revvtabletoolbar-btn-title margin-left">
                        Row Options
                      </span>
                    )}
                    {this._showOrHideRowColBtn(component) && (
                      <RowOptionBtns
                        editorState={this.props.editorState}
                        addRow={this._addRow}
                        removeRow={this._removeRow}
                        toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                        activeToolbarDropDown={this.props.activeToolbarDropDown}
                        metaData={this.props.metaData}
                        component={component}
                        saveMetaData={this.props.saveMetaData}
                        saveTable={this._saveTable}
                      />
                    )}

                    {this._showOrHideRowColBtn(component) && (
                      <div className="line-divide" />
                    )}

                    {this._showOrHideMergeBtn(component) && (
                      <MergeCellsBtn
                        className={this._decideMergeState()}
                        component={component}
                        activeComponentMeta={this.props.activeComponentMeta}
                        handleMergeCellsPopup={this.props.handleMergeCellsPopup}
                        preventEditorToDeactivate={
                          this.props.preventEditorToDeactivate
                        }
                        mergeCells={this.props.mergeCells}
                        mode={this.props.mode}
                      />
                    )}

                    {this._showOrHideMergeBtn(component) && (
                      <div className="line-divide" />
                    )}

                    {this._showOrHideManageColsBtn(component) && (
                      <ManageColumnBtn
                        component={component}
                        data-test="revvtoolbar-inline-buttons"
                        editorState={this.props.editorState}
                        toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                        activeToolbarDropDown={this.props.activeToolbarDropDown}
                        metaData={this.props.metaData}
                        showManageColumn={this.props.showManageColumn}
                        updateState={this.props.updateState}
                        preventEditorToDeactivate={
                          this.props.preventEditorToDeactivate
                        }
                        mode={this.props.mode}
                        updateComponentMeta={this.props.updateComponentMeta}
                        activeComponentMeta={this.props.activeComponentMeta}
                      />
                    )}
                    {this._showOrHideManageColsBtn(component) && (
                      <div className="line-divide">
                        <span className="line" />
                      </div>
                    )}
                    {/* Apply Formula Button only for table */}
                    {this._showOrHideManageColsBtn(component) &&
                      this.props.isCellEditable &&
                      this.props.activeBlockType === "BODY" &&
                      this.props.tableSelectionType === null && (
                        <ApplyFormulaBtn
                          updateDocumentClickedComponentID={
                            this.props.updateDocumentClickedComponentID
                          }
                          section={component}
                          activeComponentMeta={this.props.activeComponentMeta}
                        />
                      )}
                  </div>
                )}
              </Fragment>
            )
          // );
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  let fieldsUsed = [];
  const {
    preventEditorFocusOnDrag,
    activeComponentMeta,
    clickedActiveComponentId,
    components,
    tableSelectionType,
    document,
    tables: tablesUsed,
  } = state.DocumentStore;
  if (props.mode === "DOCUMENT") {
    const { fields_used: formFields } = document;
    fieldsUsed = formFields;
  }

  const { component } = props;

  if (props.mode === "TEMPLATE") {
    const { template } = state.TemplateStore;
    const { fields_used: formFields } = template;
    fieldsUsed = formFields;
  }

  let activeCell = null;
  let activeCellId = null;

  let focusRowID = null;
  let focusColumnID = null;
  let selectedIndex;
  let selectedType;
  let activeBlockType;
  let cellSelections = null;
  if (activeComponentMeta && Object.keys(activeComponentMeta).length > 0) {
    const {
      tableRowId,
      tableColId,
      componentId,
      tableCellId,
      selected,
      blockType,
      cellSelection,
    } = activeComponentMeta;

    activeBlockType = blockType;

    focusRowID = tableRowId !== undefined ? tableRowId : null;
    focusColumnID = tableColId !== undefined ? tableColId : null;
    cellSelections = cellSelection || null;
    activeCellId = tableCellId;
    if (selected && Object.keys(selected).length > 0) {
      [selectedIndex, selectedType] = selected;
    }

    activeCell =
      component && component.id === componentId
        ? [tableRowId, tableColId]
        : null;
  }
  return {
    preventEditorFocusOnDrag,
    activeCell,
    activeCellId,
    focusRowID,
    focusColumnID,
    cellSelections,
    activeComponentMeta,
    clickedActiveComponentId,
    selectedIndex,
    selectedType,
    components,
    activeBlockType,
    tableSelectionType,
    fieldsUsed,
    tablesUsed,
  };
};

const mapDispatchToProps = {
  updateDocumentClickedComponentID,
  nukeActiveEditor,
  updateActiveComponent,
  preventEditorToDeactivate,
  updateComponentMeta,
  updateDocumentComponentAction,
  coverpageThemeAction,
  tableAddRow,
  tableAddCol,
  tableDeleteRow,
  tableDeleteCol,
  tableRowUpdate,
  tableMetaUpdate,
  tableBatchCellsUpdate,
};

export default connect(mapStateToProps, mapDispatchToProps)(RevvTableToolBar);
